<template>
  <section v-if="feature" class="popup">
    <div class="card">
      <div class="card-header">
        <div class="card-header-title">{{ localization("app-details", "Details") }}</div>
        <div class="card-header-icon" @click="$emit('close')">
          <svg viewBox="0 0 100 100" class="image is-16x16 mr-10">
            <use xlink:href="@/assets/icons/helper_sprite.svg#close" />
          </svg>
        </div>
      </div>
      <smooth-scrollbar>
        <div class="card-content" style="padding:0;">
          <b-tabs expanded v-model="active_tab">
            <b-tab-item :label="localization('app-issue', 'Issue')">
              <vector-details v-if="feature" :feature="feature"></vector-details>
            </b-tab-item>
            <b-tab-item :label="localization('app-raw-images', 'Raw Images')">
              <smooth-scrollbar>
                <div v-if="raw_images.length" style="height:80vh;text-align:center">
                  <h2 style="margin-top:1rem;font-size:1rem;font-weight:500">
                    {{ localization("app-total-raw-images", "Total Raw images") }} : {{ raw_images.length }}
                    <span @click="display_raw_images()" class="has-text-info is-pointer">{{
                      localization("app-check-markers", "check markers")
                    }}</span>
                  </h2>
                  <raw-image-map v-for="(img, i) in raw_images" :key="i" :index="i" :raw_image="img"></raw-image-map>
                </div>
                <div v-else style="padding:1rem;text-align:center">
                  {{ localization("app-no-raw-images-provided", "No RawImages Provided") }}
                </div>
              </smooth-scrollbar>
              <br />
            </b-tab-item>
          </b-tabs>
        </div>
      </smooth-scrollbar>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import vectorDetails from "./vector-details/vector-details.component";
import rawImageMap from "./vector-details/raw-image.component";
import ApiService from "./../../../api.service";
const apiService = new ApiService();

export default {
  props: ["feature"],

  data() {
    return {
      apiService,
      is_raw_images: false,
      raw_images: [],
      active_tab: 0,
      map: null,
      marker: null,
      raw_image_total: null,
      raw_image_active: 0,
      is_marker: true,
      marker_element: null,
    };
  },
  components: {
    vectorDetails,
    rawImageMap,
  },
  computed: {
    ...mapState(["token", "raw_images_map"]),
  },
  watch: {
    feature: function (val) {
      if (this.feature && this.feature.properties.raw_images) {
        this.raw_images = [];
        this.get_images_urls();
      }
    },
  },
  methods: {
    async display_raw_images() {
      let { data } = await apiService.get(this.feature.properties.raw_images);
      if (data && data.length) {
        this.$root.$emit("is_popup_active", data);
      }
    },
    async get_images_urls() {
      console.log(this.feature.properties.raw_images);
      // this.raw_images = [
      //   {
      //     src:
      //       "https://sensehawk-mumbai.s3.ap-south-1.amazonaws.com/hawkai/J5o5Q7jgYa/raw_images/704.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAYTAH2T3H5HQTN7EE%2F20200302%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20200302T084827Z&X-Amz-Expires=21600&X-Amz-Signature=d390c7b13b37ac57bb0581157b88743715eafbec62570c02aeecfed65bb21cfa&X-Amz-SignedHeaders=host",
      //     location: [300, 275]
      //   },
      //   {
      //     src:
      //       "https://sensehawk-mumbai.s3.ap-south-1.amazonaws.com/hawkai/J5o5Q7jgYa/raw_images/703.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAYTAH2T3H5HQTN7EE%2F20200302%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20200302T084827Z&X-Amz-Expires=21600&X-Amz-Signature=6aea9927977a5ccd2057244db56f9ba1df2fb21626d5de19aacc77bd95ec35df&X-Amz-SignedHeaders=host",
      //     location: [326, 223]
      //   },
      //   {
      //     src:
      //       "https://sensehawk-mumbai.s3.ap-south-1.amazonaws.com/hawkai/J5o5Q7jgYa/raw_images/888.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAYTAH2T3H5HQTN7EE%2F20200302%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20200302T084827Z&X-Amz-Expires=21600&X-Amz-Signature=f53a8ee8d3313422db135f0d65c901fefcda90c911a4fffde4b46fb837ae7ba4&X-Amz-SignedHeaders=host",
      //     location: [292, 360]
      //   },
      //   {
      //     src:
      //       "https://sensehawk-mumbai.s3.ap-south-1.amazonaws.com/hawkai/J5o5Q7jgYa/raw_images/889.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAYTAH2T3H5HQTN7EE%2F20200302%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20200302T084827Z&X-Amz-Expires=21600&X-Amz-Signature=7fc007e9fc2eba2d608ee39d1d136d50c0002839342b6aeb993455f4525f7059&X-Amz-SignedHeaders=host",
      //     location: [296, 399]
      //   }
      // ];
      let { data } = await apiService.get(this.feature.properties.raw_images);
      if (data && data.length) {
        console.log(data);
        let valid_data = [];

        for (let i = 0; i < data.length; i++) {
          await fetch(data[i].src, {})
            .then((res) => {
              if (res.ok) {
                valid_data.push(data[i]);
              } else {
                console.log(data[i].src, "Image does not exist.");
              }
              this.raw_images = valid_data;
            })
            .catch((err) => console.log("Error:", err));
        }
      }
    },
  },
};
</script>
<style lang="scss">
.popup {
  .card-content {
    height: calc(100vh - 48px);
  }

  font-family: Barlow-SemiBold;
  top: 0;
  position: fixed;
  right: 0px;
  height: 100vh;
  width: 300px;
  z-index: 1000;

  .b-tabs .tab-content {
    padding: 0 0 1rem 0;
  }

  background: white;

  // height: 500px;
  // .marker-toggle {
  //   position: absolute;
  //   z-index: 2;
  //   top: 25px;
  //   left: 25px;
  //   color: white;
  //   .button {
  //     margin-right: 5px;
  //   }
  // }
  .controls {
    display: flex;
    justify-content: center;
  }

  .rawImageMap {
    position: relative;
    min-height: 250px;
    width: 98%;
  }

  .marker {
    color: #5c7ef7;
    cursor: pointer;
  }

  .mapboxgl-ctrl-logo {
    display: none !important;
  }

  .tabs {
    box-shadow: 0 0px 0px 1px rgba(0, 0, 0, 0.1);
    background-color: #f4f7fc;
  }

  .tabs a {
    border-bottom-width: 3px;
    border-bottom-color: transparent;
    color: #757575;
  }

  .tabs li.is-active a {
    border-bottom-width: 3px;
    border-bottom-color: #5c7ef7;
    color: black;
  }
}

.card-header-title {
  margin-left: 0.3rem;
}
</style>
